export default "__VITE_ASSET__SW$4aFTA__"